import { useEffect, useState } from "react";
import FucinoLogo from "./FucinoLogo";
import Reveal from "./Reveal";
import { photoSrc } from "@/lib/api";

export default function Hero({ site }) {
  const [mode, setMode] = useState("pickup");
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => setOffset(Math.min(window.scrollY * 0.07, 18));
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="hero-section" id="top">
      <div className="container hero-grid">
        <Reveal className="hero-copy">
          <span className="eyebrow">Mine Hill Township · NJ · Since today</span>
          <h1 className="display-title">The neighborhood&apos;s pizza. <em>Made with respect.</em></h1>
          <p className="hero-subhead">House favorites, crispy edges, and the kind of kitchen care you can taste. Order fresh for {mode} and get <strong>{site.promo}</strong>.</p>
          <div className="hero-actions">
            <a className="btn btn-primary" href={site.order_url} target="_blank" rel="noreferrer" data-testid="hero-start-order-button">Start your order ↗</a>
            <a className="btn" href="#menu" data-testid="hero-view-menu-button">Explore the menu ↓</a>
          </div>
          <div className="hero-stats" data-testid="hero-business-stats">
            <div className="hero-stat"><strong>10%</strong><span>Online only offer</span></div>
            <div className="hero-stat"><strong>271</strong><span>US-46, Mine Hill</span></div>
            <div className="hero-stat"><strong>2 ways</strong><span>Delivery + pickup</span></div>
          </div>
          <div className="mode-switch" data-testid="hero-order-mode-switch">
            <button className={`mode-button ${mode === "pickup" ? "active" : ""}`} type="button" onClick={() => setMode("pickup")} data-testid="hero-order-mode-pickup-tab">Pickup</button>
            <button className={`mode-button ${mode === "delivery" ? "active" : ""}`} type="button" onClick={() => setMode("delivery")} data-testid="hero-order-mode-delivery-tab">Delivery</button>
          </div>
        </Reveal>
        <Reveal className="hero-art">
          <div className="hero-note">10% off online only</div>
          <div className="hero-image-frame">
            <img className="hero-image" src={photoSrc(site.hero_image_url)} alt="Artisan pizza with blistered crust and fresh toppings" style={{ transform: `translateY(${offset}px) scale(1.04)` }} data-testid="hero-pizza-image" />
            <div className="hero-seal"><FucinoLogo src={site.logo_url} testId="hero-fucino-logo" /></div>
            <div className="hero-caption"><strong>House favorites</strong><span>made for the table</span></div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
